module.exports = __webpack_public_path__ + "static/media/campeonato.8ee53217.svg";